import { IPromise, IQService } from "angular";
import { IModalService, IModalServiceInstance } from "angular-ui-bootstrap";
import { ITraceRootScopeService } from "@gtmhub/core/tracing";
import { Metric } from "@webapp/okrs/metrics/models/metric.models";
import { IItemSelectorOptions, ISelection } from "../components/single-goal-selector/single-goal-selector.component";
import { IGoal } from "../models";
import { GoalService } from "./goal.service";

interface ISingleGoalSelectorModalParams extends IItemSelectorOptions {
  metric?: Metric;
  method?: "select";
}

export class GoalModalsService {
  public static $inject = ["$uibModal", "$q", "GoalService", "$rootScope"];

  constructor(private $uibModal: IModalService, private $q: IQService, private goalService: GoalService, private $rootScope: ITraceRootScopeService) {}

  private openSingleGoalSelectorModal(params: ISingleGoalSelectorModalParams): IModalServiceInstance {
    return this.$uibModal.open({
      template: `
        <single-goal-selector
          exclude-session-id='${params.excludeSessionId || ""}'
          planning-session-id='${params.planningSessionId || ""}'
          unselectable-id='${params.unselectableId || ""}'
          invoked-by-id='${params.invokedById || ""}'
          invoked-by='${params.invokedBy || ""}'
          include-metrics='${typeof params.includeMetrics === "boolean" ? params.includeMetrics : ""}'
          show-future-sessions='${!!params.showFutureSessions}'
          show-archived-sessions='${!!params.showArchivedSessions}'
          enable-okr-selection-only='${!!params.enableOkrSelectionOnly}'
          cancel="$dismiss()"
          select="$close(selection)">
        </single-goal-selector>
      `,
      windowClass: "single-goal-selector-modal large-small",
      lazyLoadState: "gtmhub.goals",
    });
  }

  public openGoalSelectModal(options: IItemSelectorOptions): IPromise<ISelection> {
    const modalInstance = this.openSingleGoalSelectorModal({ method: "select", ...options });
    return modalInstance.result;
  }

  public selectGoal(options: IItemSelectorOptions): IPromise<IGoal> {
    return this.openGoalSelectModal(options).then((selection: ISelection) => {
      return this.$rootScope.traceAction("select_goal", () => {
        if (selection.type === "goal") {
          return this.goalService.getGoal(selection.goal.id);
        }

        return this.$q.reject(`Invalid selection '${selection.type}', expected goal`);
      });
    });
  }
}
